import { newToolFilterOAuthMcp } from "../oauth.ts";

export const miroMcpResolver = newToolFilterOAuthMcp({
  iconUrl:
    "https://framerusercontent.com/images/6FBG66PBxjV2QFaDfIdUi5mi9A.png",
  // Root, not `/mcp`: Miro serves its OAuth protected-resource metadata only
  // at the root well-known URL, which the gateway derives from this URL.
  // TODO: revert to `/mcp` once the gateway follows the WWW-Authenticate
  // `resource_metadata` challenge (see TODO(ENG-8593) in agentic-gateway's
  // auth-server/src/mcp-client/protected-resource.ts).
  url: "https://mcp.miro.com/",
  label: "Miro",
});
